<template>
  <div>
    <navHeader></navHeader>
    <div class="container-lg mt-5">
      <div class="row border-bottom">
        <div class="col-lg-8 col-md-12 col-12">
          <div class="p-3">
            <h2 class="main-title">Stocks With Momentum Archive</h2>
            <label
              >Set of stocks screened with technical parameters that can help traders in identifying which stocks they should look further into. Best suited for those who are into short term trading or those lenient towards technical analysis.</label
            >
          </div>
        </div>
        <div class="col-lg-4 col-md-12 col-12">
          <div class="p-3 d-flex align-items-center justify-content-lg-end mt-lg-5">
            <date-picker
              class="date-picker"
              v-model="date"
              range
              :default-value="date"
              @clear="ChangeDate"
              :class="{ error: $v.date.$error }"
            ></date-picker>
            <button class="btn glob-btn" @click="Search(date)">Search</button>
          </div>
        </div>
      </div>

      <ul style="list-style-type: circle; margin-top: 2em" v-if="loading == false">
        <li
          v-for="(item, index) in generateList(StocksWithMomentumArchive)[
            currentPage - 1
          ]"
          :key="index"
        >
          <a href="javascript:void(0)" @click="ViewReport(item.date)">
            {{ FormatDate(item.date) }}
          </a>
        </li>
      </ul>

      <div class="d-flex justify-content-center mt-5">
        <b-pagination
          size="lg"
          v-model="currentPage"
          :total-rows="StocksWithMomentumArchive.length"
          :per-page="perPage"
          v-if="StocksWithMomentumArchive.length > perPage"
        ></b-pagination>
      </div>
      <Noresult v-if="StocksWithMomentumArchive.length == 0 && loading == false" />
      <Searching v-if="loading == true" />
    </div>
  </div>
</template>

<script>
import navHeader from "../../NavHeader.vue";
import { mapState } from "vuex";
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import Noresult from "../../NoResult";
import Searching from "../../Searching.vue";
export default {
  components: {
    navHeader,
    Noresult,
    Searching,
  },
  data() {
    return {
      perPage: 30,
      currentPage: 1,
      marketPrimerModalShow: false,
      date: [
        new Date(moment().startOf("year").format("MM/DD/YYYY")),
        new Date(moment().format("MM/DD/YYYY")),
      ],
      dateFrom: "",
      dateTo: "",
      loading: false,
    };
  },
  validations: {
    date: { required },
  },
  computed: {
    ...mapState({
      StocksWithMomentumArchive: (state) =>
        state.philstocksResearch.stocksWithMomentumArchive,
    }),
  },
  methods: {
     GoogleAnalytics() {
      this.$gtag.event("ShareBuybackArchive", { method: "Google" });
    },
    ChangeDate() {
      this.dateFrom = "";
      this.dateTo = "";
      this.$v.date.$reset();
      this.date = [];
    },
    ViewReport(data) {
      this.$store.dispatch("philstocksResearch/GetStocksWithMomentum", data);
      this.$router.push("/Reports/StockMomentum?date=" + data);
    },
    FormatDate(date) {
      var result = "";
      if (date == "0001-01-01T00:00:00") {
        result = "-------";
      } else {
        result = moment(date).format("MMMM DD, YYYY");
      }
      return result;
    },

    async Search(data) {
      this.dateFrom = moment(data[0]).format("L");
      this.dateTo = moment(data[1]).format("L");
      var payload = {
        DateFrom: this.dateFrom,
        DateTo: this.dateTo,
      };
      this.$v.date.$touch();
      if (this.$v.date.$invalid) {
        this.dateFrom = "";
        this.dateTo = "";
      } else {
        var _this = this;
        this.loading = true;
        let searchArchive = await this.$store
          .dispatch("philstocksResearch/GetStocksWithMomentumArchive", payload)
          .catch(function (error) {
            console.log(error);
            _this.loading = false;
          });

        if (searchArchive) {
          _this.loading = true;
        }

        _this.loading = false;
      }
    },

    generateList(data) {
      var list = 30;
      var result = data.reduce((resultArray, item, index) => {
        const listIndex = Math.floor(index / list);
        if (!resultArray[listIndex]) {
          resultArray[listIndex] = []; // start a new list
        }
        resultArray[listIndex].push(item);
        return resultArray;
      }, []);
      return result;
    },
    async GetStocksWithMomentumArchive() {
      var _this = this;
      this.loading = true;
      var payload = {
        DateFrom: moment().startOf("year").format("MM/DD/YYYY"),
        DateTo: moment().format("MM/DD/YYYY"),
      };
      let morningPrimer = await this.$store
        .dispatch("philstocksResearch/GetStocksWithMomentumArchive", payload)
        .catch(function (error) {
          console.log(error);
          this.loading = false;
        });
      if (morningPrimer) {
        _this.loading = true;
      }
      _this.loading = false;
    },
  },

  async mounted() {
    this.GetStocksWithMomentumArchive();
  },
};
</script>
<style></style>
